
import { useState } from "react";

export default function Section({ links, tools }) {
    const id = links.filter((x) => x.name.toLowerCase().includes("tools"))[0].name.replaceAll(" ", "_");
    const [twools, setTools] = useState(tools);
    const [search, setSearch] = useState("");

    function searchTools(e) {
        e.preventDefault();
        setSearch(e.target.value);

        setTools(tools.filter((x) => x.name.toLowerCase().includes(e.target.value.toLowerCase())));
    }


    return (

        <section className="tools-section" id={id}><h1>Tools and Templates</h1>

            <input type="text" placeholder="Search..." value={search} onChange={searchTools} />
            <ul>
                {twools.sort((a, b) => a.name.localeCompare(b.name)).map((x, i) => {

                    return (
                        <li key={i} >
                            <a href={`https://api-als2.nutramax.com/assets/${x.file}?download`} target="_blank" rel="noreferrer" className="tools_link" styele={{ textDecoration: "underline" }} download={`${x.name}.pdf`}> {x.name} </a>
                            <p> {x.description} </p>
                        </li>
                    )
                })}
            </ul>
        </section>
    )

}